import View from "./View";

export const overrideGlobalUIModalLookup = (modalId: number) => {
  return null;
};

export default View;
